var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "number-range-item",
      style: _vm._style,
      attrs: { width: _vm.width, heigth: _vm.height },
    },
    [
      _c("el-input", {
        attrs: { placeholder: _vm.placeHolder[0] },
        on: {
          input: _vm.inputStart,
          change: _vm.changeStart,
          blur: _vm.blurStart,
        },
        model: {
          value: _vm.value[0],
          callback: function ($$v) {
            _vm.$set(_vm.value, 0, $$v)
          },
          expression: "value[0]",
        },
      }),
      _c("span", { staticClass: "range-separator" }, [
        _vm._v(_vm._s(_vm.rangeSeparator)),
      ]),
      _c("el-input", {
        attrs: { placeholder: _vm.placeHolder[1] },
        on: { input: _vm.inputEnd, change: _vm.changeEnd, blur: _vm.blurEnd },
        model: {
          value: _vm.value[1],
          callback: function ($$v) {
            _vm.$set(_vm.value, 1, $$v)
          },
          expression: "value[1]",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }